'use es6';

import { combineReducers } from 'redux';
import notifications from 'ReduxMessenger/reducers/Notifications';
import AdProfileReducer from 'AdsUI/reducers/AdProfileReducer';
import LeadCostsReducer from 'AdsUI/reducers/LeadCostsReducer';
import DealsCurrencyReducer from 'AdsUI/reducers/DealsCurrencyReducer';
import AdWordsCampaignChildrenReducer from 'AdsUI/reducers/adwords/AdWordsCampaignChildrenReducer';
import AdWordsTrackingTemplateReducer from 'AdsUI/reducers/adwords/AdWordsTrackingTemplateReducer';
import NetworkAggregateReducer from 'AdsUI/reducers/NetworkAggregateReducer';
import CampaignListReducer from 'AdsUI/reducers/CampaignListReducer';
import SequenceListReducer from 'AdsUI/reducers/SequenceListReducer';
import AdWordsAdExtensionReducer from 'AdsUI/reducers/adwords/AdWordsAdExtensionReducer';
import AdWordsCampaignEntityReducer from 'AdsUI/reducers/adwords/AdWordsCampaignEntityReducer';
import RequestStatusReducer from 'AdsUI/reducers/RequestStatusReducer';
import AdWordsConversionTrackerEntitiesReducer from 'AdsUI/reducers/adwords/AdWordsConversionTrackerEntitiesReducer';
import AdWordsConversionTrackerUIReducer from 'AdsUI/reducers/adwords/AdWordsConversionTrackerUIReducer';
import GlobalFiltersReducer from 'AdsUI/reducers/GlobalFiltersReducer';
import AdWordsAdErrorsReducer from 'AdsUI/reducers/AdWordsAdErrorsReducer';
import AudiencesReducer from 'AdsUI/reducers/AudiencesReducer';
import FBAccountsWithUnacceptedToSReducer from 'AdsUI/reducers/facebook/FBAccountsWithUnacceptedToSReducer';
import NotificationEmailsReducer from 'AdsUI/reducers/lead-ads/NotificationEmailsReducer';
import ColumnReducer from 'AdsUI/reducers/ColumnReducer';
import AuthReducer from 'AdsUI/reducers/AuthReducer';
import UsersReducer from 'AdsUI/reducers/UsersReducer';
import UserAttributesReducer from 'AdsUI/reducers/UserAttributesReducer';
import ConnectedUsersReducer from 'AdsUI/reducers/ConnectedUsersReducer';
import CampaignReportingReducer from 'AdsUI/reducers/CampaignReportingReducer';
import LeadAdCreationUiReducer from 'AdsUI/reducers/creation/LeadAdCreationUiReducer';
import LeadFormsReducer from 'AdsUI/reducers/creation/LeadFormsReducer';
import LeadSyncingReducer from 'AdsUI/reducers/LeadSyncingReducer';
import FBBreakdownFunnelsReducer from 'AdsUI/reducers/lead-ads/FBBreakdownFunnelsReducer';
import banners from 'AdsUI/reducers/BannerReducer';
import EventsReducer from 'AdsUI/reducers/EventsReducer';
import HubAttributesReducer from './HubAttributesReducer';
import AdCreationReducer from './AdCreationReducer';
import CampaignInfoReducer from './CampaignInfoReducer';
import CouponReducer from './CouponReducer';
import DraftsReducer from './DraftsReducer';
import AdPreviewReducer from './AdPreviewReducer';
import PropertiesReducer from './PropertiesReducer';
import ConsentPropertiesReducer from './ConsentPropertiesReducer';
import AdAccountsOverviewReducer from './AdAccountsOverviewReducer';
import AdAccountsPermissionsReducer from './AdAccountsPermissionsReducer';
import AllPermissionsReducer from './AllPermissionsReducer';
import PagesReducer from './PagesReducer';
import MarketingContactsReducer from './MarketingContactsReducer';
import AdWordsAdCreationErrorReducer from './creation/AdWordsAdCreationErrorReducer';
import UsersInfoReducer from 'AdsUI/reducers/UsersInfoReducer';
import TeamsInfoReducer from 'AdsUI/reducers/TeamsInfoReducer';
import AdEditUiReducer from 'AdsUI/reducers/AdEditUiReducer';
import LifecycleStagesReducer from 'AdsUI/reducers/LifecycleStagesReducer';
import AutomationReducer from 'AdsUI/reducers/AutomationReducer';
const AppReducer = combineReducers({
  auth: AuthReducer,
  adProfile: AdProfileReducer,
  adAccountsOverview: AdAccountsOverviewReducer,
  adAccountsPermissions: AdAccountsPermissionsReducer,
  connectedUsers: ConnectedUsersReducer,
  leadCosts: LeadCostsReducer,
  dealsCurrency: DealsCurrencyReducer,
  hubAttributes: HubAttributesReducer,
  notifications,
  banners,
  requestStatus: RequestStatusReducer,
  globalFilters: GlobalFiltersReducer,
  adWordsAdErrors: AdWordsAdErrorsReducer,
  uiReducer: combineReducers({
    adWordsConversionTracker: AdWordsConversionTrackerUIReducer,
    leadAdCreation: LeadAdCreationUiReducer,
    adEdit: AdEditUiReducer
  }),
  networkAggregates: NetworkAggregateReducer,
  campaignList: CampaignListReducer,
  sequenceList: SequenceListReducer,
  allPermissions: AllPermissionsReducer,
  adWordsTrackingTemplateReducer: AdWordsTrackingTemplateReducer,
  adWordsCampaign: combineReducers({
    campaignChildren: AdWordsCampaignChildrenReducer
  }),
  adWordsAdExtensions: AdWordsAdExtensionReducer,
  // AdWords Entity Reducers //
  adWordsCampaignEntities: AdWordsCampaignEntityReducer,
  adWordsConversionTrackerEntities: AdWordsConversionTrackerEntitiesReducer,
  adPreviews: AdPreviewReducer,
  audiences: AudiencesReducer,
  columns: ColumnReducer,
  notificationEmails: NotificationEmailsReducer,
  fbAccountsWithUnacceptedToS: FBAccountsWithUnacceptedToSReducer,
  fbBreakdownFunnels: FBBreakdownFunnelsReducer,
  users: UsersReducer,
  userAttributes: UserAttributesReducer,
  reporting: CampaignReportingReducer,
  adCreation: AdCreationReducer,
  campaignInfo: CampaignInfoReducer,
  events: EventsReducer,
  leadForms: LeadFormsReducer,
  leadSyncingEntities: LeadSyncingReducer,
  coupons: CouponReducer,
  drafts: DraftsReducer,
  hsProperties: PropertiesReducer,
  consentProperties: ConsentPropertiesReducer,
  pages: PagesReducer,
  marketingContacts: MarketingContactsReducer,
  adWordsAdCreationErrors: AdWordsAdCreationErrorReducer,
  usersInfo: UsersInfoReducer,
  teamsInfo: TeamsInfoReducer,
  lifecycleStages: LifecycleStagesReducer,
  automation: AutomationReducer
});
export default AppReducer;